import React, { useState, useEffect } from 'react';
import './EmailCapture.css';

export default function EmailCapture({ result, onSubmit }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  const handleSubmit = async () => {
    if (!email.includes('@') || !email.includes('.')) {
      setError('Bitte gib eine gültige E-Mail-Adresse ein.');
      return;
    }
    setLoading(true); setError('');
    try {
      await fetch('/api/save_result.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, type: result }),
      });
    } catch (e) {}
    setTimeout(() => { setLoading(false); onSubmit(email); }, 800);
  };

  return (
    <div className="capture-page" style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.5s' }}>
      <nav className="test-nav" style={{display:'flex',alignItems:'center',padding:'0 48px',height:64,background:'#fff',borderBottom:'1px solid var(--border)'}}>
        <span className="logo-text" style={{fontFamily:'Nunito,sans-serif',fontSize:20,fontWeight:900,letterSpacing:'-0.03em'}}>
          <span style={{color:'var(--teal)'}}>ICH</span><span style={{color:'var(--text)'}}>TYPE</span><span style={{fontSize:11,fontWeight:700,color:'var(--text3)',marginLeft:1}}>.DE</span>
        </span>
      </nav>
      <main className="capture-main">
        <div className="capture-card">
          <div className="result-tease">
            <div className="tease-circle">
              <div className="tease-emoji">🎭</div>
              <div className="tease-code">{result}</div>
            </div>
            <div className="tease-lock">🔒</div>
          </div>
          <h2 className="capture-title">Dein Ergebnis ist bereit!</h2>
          <p className="capture-sub">
            Gib deine E-Mail ein und erhalte deinen vollständigen Persönlichkeitsbericht — kostenlos, sofort, direkt in dein Postfach.
          </p>
          <div className="capture-form">
            <input type="email" className="email-input" placeholder="deine@email.de"
              value={email} onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
            <button className="btn-unlock" onClick={handleSubmit} disabled={loading}>
              {loading ? (
                <span className="loading-dots"><span/><span/><span/></span>
              ) : '🔓 Ergebnis freischalten'}
            </button>
            {error && <p className="capture-error">{error}</p>}
          </div>
          <p className="capture-legal">
            Mit der Eingabe deiner E-Mail stimmst du zu, gelegentlich relevante Inhalte zu erhalten. Kein Spam. Abmeldung jederzeit möglich.
          </p>
        </div>
      </main>
    </div>
  );
}
